import type { CampaignTemplatesQueryVariables } from '~/api/graphql/queries/campaignTemplates.generated';
import type { IUseQueryCampaignsByTypeReturn } from '~/modules/campaign-template';

import { CAMPAIGN_TYPE, CAMPAIGNS_QUERY_PAGE_SIZE } from '~/constants/campaign';
import { useQueryCampaignsByType } from '~/modules/campaign-template';
import { useCampaignStore } from '~/modules/campaign';

export const campaignPricesQueryVariables: CampaignTemplatesQueryVariables = {
  first: CAMPAIGNS_QUERY_PAGE_SIZE,
  where: {
    type: CAMPAIGN_TYPE.PRICE,
    hasVariants: true,
    deletedAtIsNil: true,
  },
};

export const useQueryCampaignPrices = (): IUseQueryCampaignsByTypeReturn => {
  const isQueryCampaignPrice = useCampaignStore((state) => state.isQueryCampaignPrice);
  const setIsQueryCampaignPrice = useCampaignStore((state) => state.setIsQueryCampaignPrice);

  return useQueryCampaignsByType({
    type: CAMPAIGN_TYPE.PRICE,
    queryVariables: campaignPricesQueryVariables,
    isQueried: isQueryCampaignPrice,
    setIsQueried: setIsQueryCampaignPrice,
    getIsQueried: () => useCampaignStore.getState().isQueryCampaignPrice,
    sentrySource: 'useQueryCampaignPrices',
  });
};
